<!-- YongFeedbackContent.vue -->
<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/yong.jpg"
        alt="RHAYMART JOE O. GELLA"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-white">
        RHAYMART JOE O. GELLA
      </h1>
      <h2 class="text-sm sm:text-base md:text-lg text-white mb-5">
        Supervising Administrative Officer
      </h2>
    </div>

    <!-- Text + Image Section -->
    <div
      class="flex flex-col-reverse xl:flex-row items-center xl:items-stretch justify-center gap-6 xl:gap-10 mt-6 md:mt-8 w-full max-w-6xl"
    >
      <!-- Text Section -->
      <div class="flex-1 bg-transparent flex items-start justify-center">
        <p
          class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
        >
          When I joined Davao del Norte State College in February 2018, the
          preparation of Project Procurement Management Plans (PPMPs) was still
          done manually. At that time, as a Budget Officer, I personally
          experienced the difficulty of reviewing numerous PPMPs submitted by
          different offices. It was a tedious process to go through each item
          and ensure that the total amount was accurate and within the allowable
          budget. Errors in manual computations were common, and verifying
          figures took a significant amount of time and effort.
        </p>
      </div>

      <!-- Image Section -->
      <div class="flex-1 flex justify-center items-stretch">
        <img
          src="@/assets/img/yong-1.jpg"
          alt="RHAYMART JOE O. GELLA"
          class="w-full lg:h-[270px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        With the introduction and eventual implementation of the Fund and
        Requisition Management System (FRMS), formerly known as the Procurement
        Management System, the entire process became more efficient, accurate,
        and transparent. One of the most helpful features of the FRMS is its
        built-in safeguard that automatically prevents fund managers from
        exceeding their approved budget allocation. This feature alone has
        addressed one of the major challenges we used to encounter when doing
        manual reviews. The system performs real-time calculations, reducing the
        need for repetitive checking and minimizing human error.
      </p>
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        As a former Budget Officer and later as Finance Director, I have seen
        how the FRMS significantly improved budget execution and accountability
        within the College. It provides a convenient platform for monitoring the
        progress of fund managers in preparing their PPMPs and Purchase Requests
        (PRs). It also allows easy tracking of budget utilization rates, making
        it possible to assess how efficiently funds are being used. These
        functions are vital in ensuring that the College maintains sound
        financial management and transparency in its operations.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Now, as a fund manager myself, I truly appreciate how user-friendly and
        accessible the system is. The FRMS allows me to prepare my PPMPs anytime
        and anywhere, as long as there is an internet connection. This
        flexibility is a major improvement compared to the old manual process,
        which required printed documents and face-to-face submissions. The
        system not only saves time but also supports paperless and
        environmentally friendly operations.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Overall, the Fund and Requisition Management System has transformed how
        we manage funds, plan procurements, and monitor budget performance at
        Davao del Norte State College. It has made work easier, faster, and more
        accurate, helping me become more efficient and effective in performing
        my varying functions. The FRMS truly reflects the College’s commitment
        to innovation, good governance, and continuous improvement in financial
        and administrative processes.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-5 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "YongFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 27rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 75rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 6rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 23rem;
  }
}

/* Scrollbar styling */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
